import debtInstallmentBillRouters from './debt-installment-bill/router';
import debtInstallmentWarrantyRouters from './debt-installment-warranty/router';
import debtInstallmentOrderRouters from './debt-installment-order/router';
import debtInstallmentRouters from './debt-installment/router';
import debtProviderRouters from './debt-providers/router';
import debtSupplierDueDateRouters from './debt-supplier-due-date/router';
import debtCreditBillRouters from './debt-credit-bill/router';
import debtCreditOrderRouters from './debt-credit-order/router';
import debtShipFeeOrderRouters from './debt-shipfee-order/router';

export default [
  {
    path: 'accounting/debts',
    name: 'accountant-debt',
    component: () => import(/* webpackChunkName: "debt" */ './Debt.vue'),
    meta: {
      title: 'Công nợ - Clickbuy',
    },
    children: [
      ...debtProviderRouters,
      ...debtSupplierDueDateRouters,
      ...debtInstallmentRouters,
      ...debtInstallmentBillRouters,
      ...debtInstallmentWarrantyRouters,
      ...debtInstallmentOrderRouters,
      ...debtCreditBillRouters,
      ...debtCreditOrderRouters,
      ...debtShipFeeOrderRouters,
    ],
  },
];
